import { observeMomentsSubject } from './slices/appSlice';

import type { MomentsApiSessionReadiness } from './api/momentsApi';
import type { BaseQueryApi } from '@reduxjs/toolkit/query';

export const getMomentsGeneration = (state: unknown): number | undefined => {
  if (!state || typeof state !== 'object' || !('app' in state)) {
    return undefined;
  }
  const { app } = state;
  if (!app || typeof app !== 'object' || !('momentsGeneration' in app)) {
    return undefined;
  }
  return typeof app.momentsGeneration === 'number'
    ? app.momentsGeneration
    : undefined;
};

export const observeMomentsReadinessIdentity = (
  queryApi: BaseQueryApi,
  readiness: MomentsApiSessionReadiness,
  baseUrl: string,
) => {
  queryApi.dispatch(
    observeMomentsSubject(
      JSON.stringify([
        baseUrl,
        readiness.person?.id,
        readiness.person?.organizationId,
        [...readiness.roles].sort(),
        readiness.capabilities.memberApi,
      ]),
    ),
  );
};
